import { TDevice } from '@cian/utils';

export const initialDeviceWidth = (deviceType: TDevice): number => {
  switch (deviceType) {
    case 'phone':
      return 320;

    case 'tablet':
      return 768;

    case 'desktop':
    default:
      return 1024;
  }
};
